/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SharedHotelLocalizedCurrencyAmount } from "./SharedHotelLocalizedCurrencyAmount";
import {
  SharedHotelLocalizedCurrencyAmountFromJSON,
  SharedHotelLocalizedCurrencyAmountFromJSONTyped,
  SharedHotelLocalizedCurrencyAmountToJSON,
  SharedHotelLocalizedCurrencyAmountToJSONTyped,
} from "./SharedHotelLocalizedCurrencyAmount";

/**
 *
 * @export
 * @interface SharedHotelCurrencyAmount
 */
export interface SharedHotelCurrencyAmount {
  /**
   *
   * @type {number}
   * @memberof SharedHotelCurrencyAmount
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof SharedHotelCurrencyAmount
   */
  currency: string;
  /**
   *
   * @type {SharedHotelLocalizedCurrencyAmount}
   * @memberof SharedHotelCurrencyAmount
   */
  localizedAmount?: SharedHotelLocalizedCurrencyAmount;
}

/**
 * Check if a given object implements the SharedHotelCurrencyAmount interface.
 */
export function instanceOfSharedHotelCurrencyAmount(
  value: object
): value is SharedHotelCurrencyAmount {
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  return true;
}

export function SharedHotelCurrencyAmountFromJSON(
  json: any
): SharedHotelCurrencyAmount {
  return SharedHotelCurrencyAmountFromJSONTyped(json, false);
}

export function SharedHotelCurrencyAmountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelCurrencyAmount {
  if (json == null) {
    return json;
  }
  return {
    value: json["value"],
    currency: json["currency"],
    localizedAmount:
      json["localized_amount"] == null
        ? undefined
        : SharedHotelLocalizedCurrencyAmountFromJSON(json["localized_amount"]),
  };
}

export function SharedHotelCurrencyAmountToJSON(
  json: any
): SharedHotelCurrencyAmount {
  return SharedHotelCurrencyAmountToJSONTyped(json, false);
}

export function SharedHotelCurrencyAmountToJSONTyped(
  value?: SharedHotelCurrencyAmount | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
    currency: value["currency"],
    localized_amount: SharedHotelLocalizedCurrencyAmountToJSON(
      value["localizedAmount"]
    ),
  };
}
